import React from 'react';
import './Blogs.css';
import { FaMedium } from 'react-icons/fa';

const blogs = [
  {
    title: "Perhaps not Boring Technology after all",
    platform: "Simon Willison's Blog",
    icon: <FaMedium />,
    link: "https://simonwillison.net/2024/Jun/5/notboring/",
    description: "A deep dive into the world of technology, exploring the latest trends and innovations that are shaping our future. From AI advancements to groundbreaking startups, this blog post offers insights into why technology is anything but boring.",
  },
  {
  title: "The Illustrated Transformer",
  platform: "Jay Alammar's Blog",
  icon: <FaMedium />,
  link: "https://jalammar.github.io/illustrated-transformer/",
  description: "A visually rich and intuitive explanation of the Transformer architecture that powers modern AI models. Great for understanding attention mechanisms without getting lost in heavy math.",
},
{
  title: "AI Snake Oil",
  platform: "Arvind Narayanan's Blog",
  icon: <FaMedium />,
  link: "https://www.aisnakeoil.com/",
  description: "Critically examines the real-world claims around AI, separating genuine innovation from overhyped promises. Useful for developing a grounded perspective on AI capabilities.",
},
{
  title: "Wait But Why – AI Revolution",
  platform: "Wait But Why",
  icon: <FaMedium />,
  link: "https://waitbutwhy.com/2015/01/artificial-intelligence-revolution-1.html",
  description: "A long-form, highly engaging exploration of artificial intelligence and its future impact, explained with humor and deep insight.",
},
{
  title: "Stratechery",
  platform: "Ben Thompson",
  icon: <FaMedium />,
  link: "https://stratechery.com/",
  description: "In-depth analysis of technology companies, business models, and strategy. Especially useful for understanding how big tech operates and evolves.",
},
{
  title: "The Pragmatic Engineer",
  platform: "Gergely Orosz",
  icon: <FaMedium />,
  link: "https://blog.pragmaticengineer.com/",
  description: "Practical insights into software engineering, system design, and how tech companies build and scale products in the real world.",
},
{
  title: "Overreacted",
  platform: "Dan Abramov",
  icon: <FaMedium />,
  link: "https://overreacted.io/",
  description: "Deep dives into React, JavaScript, and programming concepts, explained with clarity and strong mental models.",
},
{
  title: "A16Z Future",
  platform: "Andreessen Horowitz",
  icon: <FaMedium />,
  link: "https://a16z.com/news-content/",
  description: "Covers emerging technologies, startups, crypto, and the future of software with a venture capital perspective.",
},
{
  title: "Engineering at Meta",
  platform: "Meta Engineering Blog",
  icon: <FaMedium />,
  link: "https://engineering.fb.com/",
  description: "Technical deep dives into large-scale systems, infrastructure, and engineering challenges faced at Meta.",
},
{
  title: "Netflix Tech Blog",
  platform: "Netflix",
  icon: <FaMedium />,
  link: "https://netflixtechblog.com/",
  description: "Explores distributed systems, scalability, and real-world engineering problems solved at Netflix.",
},
{
  title: "Google AI Blog",
  platform: "Google",
  icon: <FaMedium />,
  link: "https://ai.googleblog.com/",
  description: "Updates on cutting-edge AI research, models, and applications directly from Google’s AI teams.",
}
];

const Blogs: React.FC = () => {
  return (
    <div className="blogs-container">
      <h2 className="blogs-title">Recommended Blog Posts</h2>
      <p className="blogs-intro">A collection of blogs that I read on software development.</p>
      <div className="blogs-grid">
        {blogs.map((blog, index) => (
          <a
            href={blog.link}
            key={index}
            target="_blank"
            rel="noopener noreferrer"
            className="blog-card"
            style={{ '--delay': `${index * 0.2}s` } as React.CSSProperties}
          >
            <div className="blog-icon animated-icon">{blog.icon}</div>
            <div className="blog-info animated-text">
              <h3 className="blog-title">{blog.title}</h3>
              <p className="blog-description">{blog.description}</p>
              <span className="blog-platform">{blog.platform}</span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Blogs;
